import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Paths } from "../../router/Paths";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { useOwnProfile } from "../../hooks/useProfile";

interface TaskCardProps {
  iconSrc: string;
  title: string;
  subtitle: string;
  path: string;
}

interface CompletedProfile {
  _id: string;
  numberOfEmployees: string;
  numberOfActivities: string;
  locations: [];
  reservation: boolean;
  legalCompanyName: string;
  website: string;
  user: string;
  type: string;
  __v: number;
  logo: string | File;
  professionalLicenseNumber: string;
  firstName: string;
  lastName: string;
  legalIndividualName: string;
  publicCompanyName: string;
}

export default function WelcomeTasksSection() {
  const { getOwnProfile } = useOwnProfile();
  const [isCompletedProfile, setIsCompletedProfile] = useState<
    CompletedProfile | undefined
  >();
  const [loading, setLoading] = useState<boolean>(false);

  const [completedTasks, setCompletedTasks] = useState(() => {
    const savedTasks = localStorage.getItem("completedTasks");
    return savedTasks
      ? JSON.parse(savedTasks)
      : {
          companyInfo: false,
          contactInfo: false,
          additionalInfo: false,
        };
  });

  const totalTasks = 3;
  const completedCount = Object.values(completedTasks).filter(Boolean).length;
  const progressText = `${completedCount} of ${totalTasks}`;

  const IsCompanyCompleted = useSelector(
    (state: RootState) => state.Companypending
  );
  const IsContactCompleted = useSelector(
    (state: RootState) => state.ContanctPending
  );
  const IsAdditionalInformationCompleted = useSelector(
    (state: RootState) => state.additionalPending
  );

  useEffect(() => {
    const updatedTasks = {
      companyInfo: IsCompanyCompleted,
      contactInfo: IsContactCompleted,
      additionalInfo: IsAdditionalInformationCompleted,
    };
    setCompletedTasks(updatedTasks);
    localStorage.setItem("completedTasks", JSON.stringify(updatedTasks));
  }, [
    IsCompanyCompleted,
    IsContactCompleted,
    IsAdditionalInformationCompleted,
  ]);

  const tasks = [
    {
      key: "registration",
      iconSrc: "/Document.svg",
      title: "Add Company Information",
      subtitle: "Get all the important legal stuff out of the way",
      path: Paths.registration,
      isCompleted: completedTasks.companyInfo,
    },
    {
      key: "logo",
      iconSrc: "/Image.svg",
      title: "Add Contact Information",
      subtitle: "Let customers know it's really you with your logo",
      path: Paths.registration,
      isCompleted: completedTasks.contactInfo,
    },
    {
      key: "paymentAndTax",
      iconSrc: "/Payment.svg",
      title: "Add Additional Information.",
      subtitle: "Set up how and when you want to be paid",
      path: Paths.registration,
      isCompleted: completedTasks.additionalInfo,
    },
  ];

  const isProfileCompleted = isCompletedProfile
    ? !!(
        isCompletedProfile.firstName &&
        isCompletedProfile.lastName &&
        isCompletedProfile.type &&
        isCompletedProfile.publicCompanyName &&
        isCompletedProfile.legalCompanyName &&
        isCompletedProfile?.professionalLicenseNumber
      )
    : false;

  // const allTasksCompleted = tasks.every((task) => task.isCompleted) && isProfileCompleted;

  useEffect(() => {
    const getOwnProfileDetail = async () => {
      setLoading(true);
      const response: CompletedProfile | any = await getOwnProfile({
        setLoading,
      });
      setIsCompletedProfile(response);
      setLoading(false);
      console.log("ownprofile", response);
    };

    getOwnProfileDetail();
  }, []);

  return (
    <div className={Classname.container}>
      <div className={Classname.pendingtask}>
        <div className={Classname.textMain}>Pending tasks</div>
        <div className={Classname.taskboth}>
          {!isProfileCompleted && <div>{progressText}</div>}
        </div>
      </div>

      {loading ? (
        <div className="text-center py-5">Loading your profile...</div>
      ) : (
        <>
          {isProfileCompleted ? (
            <div className="mb-5 text-center text-primary">
              There is no pending task
            </div>
          ) : (
            <div className="mb-5">
              Complete these tasks to finish your registration process{" "}
              {tasks
                .filter((task) => !task.isCompleted)
                .map((task) => (
                  <TaskCard
                    key={task.key}
                    iconSrc={task.iconSrc}
                    title={task.title}
                    subtitle={task.subtitle}
                    path={task.path}
                  />
                ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}

const TaskCard: React.FC<TaskCardProps> = ({
  iconSrc,
  title,
  subtitle,
  path,
}) => {
  const navigate = useNavigate();
  return (
    <div className="my-3" onClick={() => navigate(path)}>
      <div className={Classname.tasksContainer}>
        <div className={Classname.tasksDetail}>
          <img src={iconSrc} alt="Task Icon" />
          <div>
            <div className={Classname.taskblue}>{title}</div>
            <div>{subtitle}</div>
          </div>
        </div>
        <img src="/Next.svg" alt="Next Icon" />
      </div>
      <div className="border-t border-gray-300 my-5"></div>
    </div>
  );
};

const Classname = {
  container:
    "bg-white rounded-lg h-fit w-full flex flex-col p-4 lg:p-6 max-w-7xl",
  textMain: "font-bold text-lg",
  pendingtask: "flex justify-between",
  taskboth: "flex gap-4",
  taskbar: "bg-gray-300 rounded-full h-2 lg:w-40 w-20 self-center",
  tasksContainer: "flex justify-between cursor-pointer",
  tasksDetail: "flex gap-4",
  taskblue: "text-blue-500",
};
